import React from 'react';

import PhotoGalleryDetail from '../PhotoGallery/PhotoGalleryDetail/PhotoGalleryDetail';
import VideoDetail from '../Video/VideoDetail';

const ResidenceView = ({
  data,
  className,
  childGalleryClassName,
  childVideoClassName,
  showInstructions,
}) => ((data?.length > 0) ? (
  <div
    id="view-scroll"
    className={className}
  >

    { data.map((item) => {
      const { type, data } = item;
      let component = null;
      switch (type) {
        case 'PhotoGallery':
          component = (
            <PhotoGalleryDetail
              key="viewGallery"
              id={null}
              className={className}
              uuid={null}
              images={data}
              showInstructions={showInstructions}
              galleryClass={childGalleryClassName}
              imageClass="slideshowPhoto"
            />
          );
          break;
        case 'Video':
          component = (
            <VideoDetail
              key={data?.videoId}
              hasId={false}
              videoId={data?.videoId}
              service={data?.service}
              autoplay={false}
              showInstructions={showInstructions}
              className={childVideoClassName}
            />
          );
          break;
        default:
      }
      return component;
    })}

  </div>
) : null);

export default ResidenceView;
